"use client"

import {useEffect, useState} from 'react';
import {useAppStore} from "@/store/AppStore";
import {Liturgies} from "@/types/Liturgies";
import {saintsRequest} from "@/utils/api/Saints";
import {useLocale} from "use-intl";

const useSaintsData = (token?: string) => {
  const locale = useLocale()
  const [data, setData] = useState<Liturgies | undefined>(undefined)
  const setRefresh = useAppStore((state) => state.setRefresh);

  useEffect(() => {
    const fetchData = async (token: string) => {
      const fetched = await saintsRequest(token, locale)
      if (false === fetched) {
        setRefresh(true)
        return true
      }
      if (fetched) {
        setData(fetched)
      }
    }
    if (!data && token) {
      fetchData(token)
    }
  }, [setRefresh, token, data, locale]);

  return data
};

export default useSaintsData;
